import { LegalLayout, LegalSection } from "../components/LegalLayout";
import { restaurantInfo } from "../mock";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="January 2026"
      seo={{
        description: "Nina's Taqueria Privacy Policy — what data we collect, how we use it, cookies, sharing practices, and CCPA rights for California residents.",
        path: "/privacy",
      }}
    >
      <LegalSection heading="1. What we collect">
        <p>
          When you contact us, place an online order, or subscribe to our updates, we may
          collect your name, email address, phone number, delivery address, and order
          preferences. Our website also collects standard technical information such as
          your IP address, browser type, and pages visited.
        </p>
      </LegalSection>
      <LegalSection heading="2. How we use it">
        <p>We use your information to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Respond to messages and inquiries</li>
          <li>Process and fulfill orders (via our ordering partner)</li>
          <li>Send occasional promotional emails when you opt in</li>
          <li>Improve our website and menu offerings</li>
        </ul>
      </LegalSection>
      <LegalSection heading="3. Cookies">
        <p>
          We use cookies to see how you interact with our site and to remember your
          preferences. You can disable cookies in your browser settings.
        </p>
      </LegalSection>
      <LegalSection heading="4. Sharing">
        <p>
          We never sell your personal information. We only share it with trusted service
          providers (payment processors, ordering platform, email tools) who help us
          operate the business, and when required by law.
        </p>
      </LegalSection>
      <LegalSection heading="5. Your rights (California residents)">
        <p>
          Under the California Consumer Privacy Act (CCPA), you have the right to know
          what personal information we hold, to request its deletion, and to opt out of
          any sale of personal information. See our{" "}
          <a href="/do-not-sell" className="text-brand hover:underline">
            Do Not Sell My Personal Information
          </a>{" "}
          page.
        </p>
      </LegalSection>
      <LegalSection heading="6. Security">
        <p>
          We use reasonable technical and organizational measures to protect your
          information. No transmission over the internet is 100% secure, so we cannot
          guarantee absolute security.
        </p>
      </LegalSection>
      <LegalSection heading="7. Contact">
        <p>
          Privacy questions? Email us at{" "}
          <a href={`mailto:${restaurantInfo.email}`} className="text-brand hover:underline">
            {restaurantInfo.email}
          </a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
